import { PaymentOverallStatus } from 'src/app/data/constants/payment-status.enum';

export enum CreativeStatus {
    Approved = 'Approved',
    Rejected = 'Rejected',
    Pending = 'Pending',
    //the misspelling in the value is intended as it matches the API
    NotAvailable = 'NotAvaliable',
    No_Status = 'No_Status'
}

export enum ProcessingStatus {
    AwaitingMedia = 'AwaitingMedia',
    Processing = 'Processing',
    Ready = 'Ready',
    ReadyForTranscoding = 'ReadyForTranscoding',
    SubmittedForTranscoding = 'SubmittedForTranscoding',
    TranscodeComplete = 'TranscodeComplete',
    TranscodingComplete = 'TranscodingComplete'
}

export interface CreativeStatusData {
    creative_id: number;
    processing_status: ProcessingStatus;
    creative_status: CreativeStatus;
    creative_status_notes: string;
    ceative_status_change_date: Date;
}

// some field can define as enum if there are only a few possible values
export class CreativeData {
    creative_id: number;
    name: string;
    ad_duration: number;
    language: string;
    external_identifier: string = '';
    creative_formats: Array<CreativeFormats>;
    creative_author: string;
    campaigns: Array<{
        campaign_id: number;
        campaign_name: string;
    }>;
    creative_type: string = 'TV-Linear TV';
    creative_product_id?: number;
    group_name?: string = '';
    creative_status?: CreativeStatus;
    processing_status?: ProcessingStatus;

    constructor() { }
}

// some field can define as enum if there are only a few possible values
export class CreativeFormats {
    media_id: number;
    cdn_url: string;
    format_type: string;
    dimension: string = '400x300';
    delivery_type: string = 'progressive';
    integration_type: string = 'Linear TV';

    constructor() { }
}

export interface CampaignAssociations {
    creative_id: number;
}

export interface CampaignCreativeStatus {
    Result: Array<{
        FlightId: number;
        FlightMediaManage: Array<{
            FlightMediaId: number;
            WatershedTimingId: number;
            ApprovalStatus: CreativeStatus;
            // MediaId is creative id
            MediaId: number;
        }>;
    }>;
    Errors?: any;
}

export interface CampaignCreativeData {
    creative_id: number;
    creative_name: string;
    brand_id: number;
    flight_media_id: number;
}

export interface CreativePaymentStatus {
    entity_id: number;
    entity_type: string;
    amount: number;
    payment_status: PaymentOverallStatus;
}

export interface AdDurationData {
    min_length_seconds: number,
    max_length_seconds: number,
    device_formats: Array<any>
}




